import data from "../../shared/sharedData";

export default {
  modalPrefill: {
    type: "worker-housing",
    machine_name: "eta_790a_addendum_b_housing",
    modal_name: "addProfilesModal",
    title: "Worker Housing Profiles",
    description:
      "Select the Worker Housing profile(s) to populate in the Addendum B table.",
    isVisible: {
      when: "eta_790a_d11_is_housing_addendum_b_completed",
      is: "YES",
    },
  },
  name: "Addendum B - Additional Housing Locations",
  pageInfo: {
    text: "This Addendum must be fully completed and submitted with the Form ETA-790A when the employer will be providing housing at additional locations, other than  the place disclosed in Section D, items 1 through 5 and/or additional space is needed to identify all available housing units for workers at the address disclosed in Section D, items 1 through 5.",
    coloring: "grey",
    isVisible: {
      when: "eta_790a_d11_is_housing_addendum_b_completed",
      is: "YES",
    },
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field D.11 whether housing will be provided at multiple locations.",
        type: "info",
        isVisible: {
          when: "eta_790a_d11_is_housing_addendum_b_completed",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description:
          "Because you indicated that housing will only be provided at one location (per Section D), no Addendum B is necessary for this application.",
        type: "success",
        isVisible: {
          when: "eta_790a_d11_is_housing_addendum_b_completed",
          is: "N/A",
        },
      },
    ],
  },
  sections: [
    {
      code: "Addendum B",
      name: "Additional Housing Locations",
      machine_name: "eta_790a_addendum_b_housing",
      isVisible: {
        when: "eta_790a_d11_is_housing_addendum_b_completed",
        is: "YES",
      },
      validate: ["tableRequired", "tableIncomplete"],
      label:
        "Use the table below to enter the details about each crop, when applicable.",
      isModal: true,
      openModalHeader: "Add Addendum B",
      modalHeader: "Add Additional Housing Locations",
      listType: "table",
      removeFromFieldArray: true,
      modalFields: [
        {
          hideOnTable: true,
          isGroup: {
            machine_name: "housing_type",
            label: "Type of Housing",
            required: true,
            coloring: "none",
            // disabled: true,
            columns: false,
            tooltip:
              "Identify the type of housing that will be provided to workers at this location by indicating either employer-provided, which includes mobile or range units, or rental and/or public accommodations.",
            fields: [
              {
                widget: "radio",
                machine_name: "housing_type",
                choice: "Employer-provided (including mobile or range)",
                value: "Employer",
                validate: ["required"],
              },
              {
                widget: "radio",
                machine_name: "housing_type",
                choice: "Rental or public accommodations",
                value: "Rental",
                validate: ["required"],
              },
            ],
          },
        },
        {
          hideOnTable: true,
          machine_name: "housing_address_1",
          label: "Physical Location - Address/Location",
          widget: "text",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address/Location must contain at least 5 characters.",
            },
          ],
          maxLength: 120,
          tooltip:
            "Enter the street address where the housing for workers is located. Use commonly understood street or highway numbers and names.",
        },
        {
          hideOnTable: true,
          machine_name: "housing_city",
          label: "Physical Location - City",
          widget: "text",
          maxLength: 35,
          validate: [
            {
              minLength: 2,
              message: "City must contain at least 2 characters",
            },
          ],
          message: "City must contain at least 2 characters",
        },
        {
          machine_name: "housing_state_id",
          label: "Physical Location - State",
          widget: "select",
          selection: data.state,
          state: true,
          validate: ["required"],
        },
        {
          machine_name: "housing_county_id",
          label: "Physical Location - County",
          widget: "countyselect",
          disabled: true,
          parent_machine_name: "add_values_field",
          disableWhenField: "housing_state_id",
          validate: [
            "required",
            {
              required_county: "housing_state_id",
              message: "add_values_field",
              needsFieldValues: true,
            },
          ],
        },
        {
          hideOnTable: true,
          machine_name: "housing_zip",
          label: "Physical Location - Postal Code",
          widget: "text",
          maxLength: 10,
          validate: [
            "postal",
            {
              maxLength: 10,
              message: "This field cannot be more than 10 characters long.",
            },
          ],
          message: "This field cannot be more than 10 characters long.",
        },
        {
          hideOnTable: true,
          machine_name: "additional_info",
          label: "Additional Housing Information",
          widget: "text_area",
          rows: 8,
          inputLimit: 500,
          maxLength: 500,
          validate: [
            {
              minLength: 5,
              message: "Additional Info must be at least 5  characters.",
            },
          ],
          tooltip:
            "Enter any additional information about the housing. Examples may include more specific directions on how workers canreach the housing, especially in very rural and isolated geographic areas; availability of family units and/or single rooms available; utilities (e.g., gas, electricity, and heat); and/or arrangements for utility hookups. This field will permit an entry of up to 500 characters.",
        },
        {
          hideOnTable: true,
          machine_name: "total_units",
          label: "Total Units",
          widget: "text",
          validate: ["required"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip:
            "Enter the total number of housing units available to house workers at this location.",
        },
        {
          hideOnTable: true,
          machine_name: "total_occ",
          widget: "text",
          label: "Total Occupancy",
          validate: ["required"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip:
            "Enter the total occupancy capacity for all of the housing units identified in Item above.",
        },
        {
          hideOnTable: true,
          isGroup: {
            label:
              "Identify the entity that determined the housing met all applicable standards:",
            tooltip:
              "Identify the entity that has determined or will determine that the housing identified in this row meets, or will meet, all applicable standards, as required. Select the appropriate boxes for each row, following the instructions for Item D.9.",
            coloring: "none",
            disabled: true,
            columns: false,
            required: true,
            machine_name: "applicable_housing_standards",
            fields: [
              {
                widget: "checkbox_old",
                machine_name: "applicable_housing_standards_local",
                choice: "Local Authority",
                label: "Local",
                hidden: true,
                value: "YES",
                validate: [
                  {
                    // Requiring a field inside a modal requires you to have add_values_field denoted
                    // like so.
                    subsetOfSetRequired: "add_values_field",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: [
                        "applicable_housing_standards_local",
                        "applicable_housing_standards_swa",
                        "applicable_housing_standards_other_state",
                        "applicable_housing_standards_federal",
                        "applicable_housing_standards_other",
                      ],
                    },
                  },
                ],
              },
              // {
              //   widget: "checkbox_old",
              //   machine_name: "applicable_housing_standards_state",
              //   choice: "State Authority",
              //   label: "State",
              //   value: "YES",
              //   hidden: true,
              // },
              {
                widget: "checkbox_old",
                machine_name: "applicable_housing_standards_swa",
                choice: "SWA",
                label: "SWA",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name: "applicable_housing_standards_other_state",
                choice: "Other State Authority",
                label: "Other State",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name: "applicable_housing_standards_federal",
                choice: "Federal Authority",
                label: "Federal",
                value: "YES",
                hidden: true,
              },
              {
                widget: "checkbox_old",
                machine_name: "applicable_housing_standards_other",
                choice: "Other (Specify)",
                label: "Other (Specify)",
                value: "YES",
                hidden: true,
                clearSchema: [
                  "add_values_field[0]applicable_housing_standards_other_text",
                ],
              },
            ],
          },
        },
        {
          label: "Specify: ",
          machine_name: "applicable_housing_standards_other_text",
          widget: "text_area",
          isVisible: {
            when: "add_values_field[0]applicable_housing_standards_other",
            is: "YES",
          },
          // extraData: {
          //   prefix: "add_values_field",
          //   type: "start",
          //   currentField: "begin_date",
          //   isModal: true,
          // },
          width: 4,
          rows: 2,
          inputLimit: 25,
          validate: [
            "required",
            {
              isRequired: "applicable_housing_standards_other_text",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "applicable_housing_standards_other_text",
              },
            },
          ],
          hideOnTable: true,
          tooltip: `Because of the selection of “Other” in the question above, enter the specific U.S. enter the specific entity that determined the housing met all applicable standards.”`,
        },
      ],
    },
  ],
};
